<template>
  <div>
    <div>
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData" label-width="90px" size="mini">
          <div class="formItemBox">
            <el-form-item label="出库单号:">
              <el-input v-model="formData.outstockNo" placeholder="请输入出库单号"></el-input>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input v-model="formData.outstockPlateNumber" placeholder="请输入车号"></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
            <el-select
            filterable
            clearable
            placeholder="请选择一级货主"
            v-model="formData.primaryCustomerTaxId"
            >
              <el-option
                v-for="(item, index) in HZData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
            <el-select
            size="mini"
            clearable
            filterable
            placeholder="请选择二级货主"
            v-model="formData.customerTaxId"
            >
              <el-option
                v-for="(item, index) in HZData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in productTypeData"
                :key="index"
                :label="item.productTypeName"
                :value="item.productType"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in steelMillNameData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in specificationData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in modelData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <!-- <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in arrivalMethodData"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
              </el-select>
          </el-form-item> -->
          <el-form-item label="出库时间:" >
            <div style="display: flex;">
              <el-date-picker
                v-model="formData.outstockDateStart"
                type="datetime"
                placeholder="选择时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              -
              <el-date-picker
                v-model="formData.outstockDateEnd"
                placeholder="选择时间"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="车船编号:">
              <el-input v-model="formData.plateNumber" placeholder="请输入车船号"></el-input>
            </el-form-item>
            </div>
            <el-form-item style="padding-left: 10px;">
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB00Y" v-if="btnFlg[33]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB00Z" v-if="btnFlg[34]">重置</el-button>
              <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB00a" v-if="btnFlg[35]">导出</el-button>
              <!-- <el-button type="primary" size="mini" @click="tareWeightClick" btnCode="00cP00BB00b" v-if="btnFlg[36]">皮重</el-button> -->
              <!-- <el-button type="primary" size="mini" @click="tareWeightChangeTime" btnCode="00cP00BB00c" v-if="btnFlg[37]">修改皮重时间</el-button> -->
              <!-- <el-button type="primary" size="mini" @click="clearTareWeight" btnCode="00cP00BB00d" v-if="btnFlg[38]">清空皮重</el-button> -->
            </el-form-item>
        </el-form>
      </div>
      <div :style="{height:h}">
          <el-table
          border
          center
          bordersize="mini"
          :data="tableData"
          height="100%"
          style="width:100%"
          size="mini"
          highlight-current-row
          @row-click="dianjixuanzhong"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          >
            <!-- <el-table-column type="selection" align="center" width="40"></el-table-column> -->
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="status" label="状态" width="100" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="130"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="grossWeight" label="毛重（重车）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tareWeight" label="皮重（空车）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weightingWeight" label="净重（吨）" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="grossWeightTime" label="毛重过磅时间" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tareWeightTime" label="皮重过磅净重（吨）" width="170" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="grossWeightOperator" label="毛重司磅员" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tareWeightOperator" label="皮重司磅员" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="estimatedSingletonWeight" label="预报实入件重(吨)" width="150" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="forecastNo" label="预报编号" align="center" width="230"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="stockNo" label="业务单号" width="230" ></el-table-column>

          </el-table>
      </div>
      <div class="pags" >
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            :page-sizes="[10,20,30,40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 毛重 -->
    <div>
      <el-dialog
        :title="changeTitle"
        :visible.sync="dialogVisiblejincang"
        :close-on-click-modal="false"
        @close="dialogVisiblejincang=false"
        width="30%"
        center
      >
        <!--form表单-->
        <el-form
          :model="changeWeightFormData"
          ref="changeWeightFormData"
          label-width="120px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item prop="tareWeight" label="皮重（吨）：" v-if="changeTitle == '皮重'"
            :rules="[
              { required: true, message: '请输入皮重', trigger: 'blur' },
            ]"
          >
            <el-input size="mini" v-model="changeWeightFormData.tareWeight" v-number-input.float="4" style="width:193px;"></el-input>
          </el-form-item>
          <el-form-item prop="" label="修改前：" v-if="changeTitle == '修改皮重时间'">
            <span>{{changeWeightFormData.tareWeightDateTimeOld}}</span>
          </el-form-item>
          <el-form-item prop="tareWeightDateTime" label="修改后：" v-if="changeTitle == '修改皮重时间'"
            :rules="[
              { required: true, message: '请选择时间', trigger: 'blur' },
            ]"
          >
          <el-date-picker
            v-model="changeWeightFormData.tareWeightDateTime"
            size="mini"
            type="datetime"
            placeholder="选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="width:180px;margin:15px auto;">
          <el-button @click="dialogVisiblejincang = false">取 消</el-button>
          <el-button type="primary" @click="updateWeight()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getRelationCustomer, getVirtualBalingList } from '@/api/wms-stock'
import {
  getOutStockWeightInfoList,
  updatetareWeight, // 修改皮重
  updatetareWeightTime, // 修改毛重时间
  clearTareWeight // 清空毛重皮重
} from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  name: 'JCRecord',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        outstockNo: '',
        outstockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        arrivalMethod: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        plateNumber: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectList: [],
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      changeTitle: '',
      changeWeightFormData: {
        tareWeight: '',
        tareWeightDateTime: '',
        tareWeightDateTimeOld: ''
      },
      dialogVisiblejincang: false,
      addLoad: false
    }
  },
  props: {
    RuKuGBVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 列表查询
    JfgetConfirmedExpLists () {
      getOutStockWeightInfoList(
        {
          outstockNo: this.formData.outstockNo,
          outstockPlateNumber: this.formData.outstockPlateNumber,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          arrivalMethod: this.formData.arrivalMethod,
          outstockDateStart: this.formData.outstockDateStart,
          outstockDateEnd: this.formData.outstockDateEnd,
          plateNumber: this.formData.plateNumber
        }
      )
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    chaxun () {
      this.JfgetConfirmedExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.outstockNo = ''
      this.formData.outstockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.arrivalMethod = ''
      this.formData.outstockDateStart = ''
      this.formData.outstockDateEnd = ''
      this.formData.plateNumber = ''
      this.JfgetConfirmedExpLists()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/shipStock/exportOutStockWeightInfoList',
        this.formData,
        '出库过磅记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetConfirmedExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetConfirmedExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 点击选中
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    // 修改皮重
    tareWeightClick () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
      } else {
        this.changeTitle = '皮重'
        this.dialogVisiblejincang = true
        this.changeWeightFormData.tareWeight = ''
        this.$nextTick(() => {
          this.$refs.changeWeightFormData.clearValidate()
        })
      }
    },
    // 修改皮重时间
    tareWeightChangeTime () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
      } else {
        this.changeTitle = '修改皮重时间'
        this.dialogVisiblejincang = true
        this.changeWeightFormData.tareWeightDateTimeOld = this.xuanzhongArr.tareWeightTime
        this.changeWeightFormData.tareWeightDateTime = ''
        this.$nextTick(() => {
          this.$refs.changeWeightFormData.clearValidate()
        })
      }
    },
    // 清空皮重
    clearTareWeight () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
      } else {
        if (this.xuanzhongArr.status == '已完成') {
          this.$message.error('已完成状态不能清空')
        } else {
          this.$confirm('确定清空吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            clearTareWeight(this.xuanzhongArr.weightInfoId)
              .then(res => {
                DonMessage.success('清楚成功')
                this.JfgetConfirmedExpLists()
              })
              .catch(error => {
                DonMessage.error(error.message)
              })
          }).catch(() => {
          })
        }
      }
    },
    updateWeight () {
      this.$refs.changeWeightFormData.validate((valid) => {
        if (valid) {
          if (this.changeTitle == '皮重') {
            this.addLoad = true
            updatetareWeight({
              weightInfoId: this.xuanzhongArr.weightInfoId, // 过磅记录id,
              tareWeight: this.changeWeightFormData.tareWeight // 毛重重量
            }).then(res => {
              this.$message.success('修改成功')
              this.addLoad = false
              this.dialogVisiblejincang = false
              this.JfgetConfirmedExpLists()
            }).catch(err => {
              this.addLoad = false
              this.$message.error(err.message)
            })
          } else if (this.changeTitle == '修改皮重时间') {
            updatetareWeightTime({
              weightInfoId: this.xuanzhongArr.weightInfoId, // 过磅记录id,
              tareWeightTime: this.changeWeightFormData.tareWeightDateTime // 皮重时间
            }).then(res => {
              this.$message.success('修改成功')
              this.addLoad = false
              this.dialogVisiblejincang = false
              this.JfgetConfirmedExpLists()
            }).catch(err => {
              this.addLoad = false
              this.$message.error(err.message)
            })
          }
        } else {
          this.addLoad = false
        }
      })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.JfgetConfirmedExpLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style>

</style>
